const motionQuery = matchMedia('(prefers-reduced-motion)');
if (motionQuery.matches) {
  const videos = Array.from(document.querySelectorAll('.video-screenshot video'));
  videos.forEach(el => el.pause());
}
